// Coerces API/mock boolean fields that may come back as a real boolean or as the string 'true'/'false'.
export const isTrue = value => value === 'true' || value === true;
